import React from "react";
import Grid from "@material-ui/core/Grid";
import {
  List,
  ListApi,
  loopback,
  autocompleteHelpers,
  Filter,
  Autocomplete,
} from "elentari";
import moment from "moment";
import { secaApi, clienteApi } from "../../services/Api";
import { Field } from "react-final-form";

const { loopbackFilters } = loopback;
const loadClientes = async (inputValue) => {
  const response = await clienteApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(autocompleteHelpers.toOption("nome"));
  }
  return [];
};

function SecaFilter(props) {
  return (
    <Filter
      formatFilters={{ clienteId: (value) => value.id }}
      labels={{ find: "Buscar", clear: "Limpar" }}
    >
      <Grid spacing={24} container>
        <Grid item xs>
          <Field
            label="Cliente"
            loadOptions={loadClientes}
            component={Autocomplete}
            name="clienteId"
          />
        </Grid>
      </Grid>
    </Filter>
  );
}

export function SecaList(props) {
  const isFromCliente = !!props.match.params.id;
  const listOptions = {
    defaultOrder: "data desc",
    fields: {
      cliente: isFromCliente
        ? null
        : {
            label: "Cliente",
            format: (cliente) => cliente.nome,
          },
      data: {
        label: "Data",
        format: (date) => (date ? moment(date).format("DD/MM/YYYY") : ""),
      },
      peso: {
        label: "Peso",
      },
      mme: {
        label: "Massa Muscular Esquelética (Kg)",
      },
      gordura: {
        label: "Gordura (Kg)",
      },
      percentual: {
        label: "Percentual de Gordura",
      },
      gorduraVisceral: {
        label: "Gordura Visceral",
      },
      circunferenciaCintura: {
        label: "Circunferência da Cintura",
      },
    },
  };

  const getPageDecorator = async ({ getPage }) => {
    const items = await getPage();
    if (!items) return;
    if (isFromCliente) return items;
    const promises = items.map(async (item) => {
      const response = await clienteApi.getOne(item.clienteId);
      if (response.ok) {
        item.cliente = {
          nome: response.data.nome,
          idSeca: item.id,
        };
        item.clienteId = undefined;
        return item;
      }
      return item;
    });
    return Promise.all(promises);
  };

  return (
    <ListApi
      api={secaApi}
      getPageDecorator={getPageDecorator}
      where={isFromCliente ? { clienteId: +props.match.params.id } : null}
    >
      {({ getPage, getCount, handleDelete }) => (
        <>
          <SecaFilter />
          <List
            {...props}
            withPaper={props.withPaper}
            deleteItem={handleDelete}
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </>
      )}
    </ListApi>
  );
}
